// Components
const ModalAddProductToBundle = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-add-product-to-bundle" */ "@/app/views/main-view/bundles/components/bundle-add-edit-component/modals/modal-add-product-to-bundle/modal-add-product-to-bundle.vue"
	)
const FileUpload = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "file-upload" */ "@/app/views/main-view/_shared/_components/file-upload/file-upload.vue"
	)
const BreedTableComponent = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "breed-table-component"*/ "@/app/views/main-view/_shared/_components/breed-table-component/breed-table-component.vue"
	)
const ModalFindReplaceWithPetName = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-find-replace-with-pet-name"*/ "@/app/views/main-view/notifications/containers/modals/modal-find-replace-with-pet-name/modal-find-replace-with-pet-name.vue"
	)
const BundleSelectProduct = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "bundle-select-product"*/ "@/app/views/main-view/bundles/components/bundle-select-products/bundle-select-products.vue"
	)

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { productMixins } from "@/app/mixins/modules/product-mixins.js"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { numberFormatMixins } from "@/app/mixins/modules/number-format-mixins"

// Services
import BundleService from "@/app/services/main/bundles/bundles-service"
import ProductService from "@/app/services/main/product/product-service"

// Constants
import { STATUS_CODES, PRODUCT_STATUS } from "@/app/constants/constants.js"

// Events
import EventBus from "@/app/bus/event-bus.js"
import _ from 'lodash';

export default {
	name: "BundleAddEditComponent",
	components: {
		ModalAddProductToBundle,
		FileUpload,
		BreedTableComponent,
		ModalFindReplaceWithPetName,
		BundleSelectProduct,
	},
	mixins: [productMixins, tableMixins, toastMessageMixins, numberFormatMixins],
	data() {
		return {
			// fields
			bundleName: null,
			dogBundleFlag: false,
			bundleEditDetails: null,
			price: "0.00",
			salePrice: "0.00",
			onSale: false,
			monthlyPrice: "0.00",
			quarterlyPrice: "0.00",
			yearlyPrice: "0.00",
			applicableBreeds: null,
			hasBreedListChanges: false,
			breedList: [],
			isAPILoading: false,
			isSendingAPIRequest: false,
			isShowNote: false,
			productDataTmp: [],
			// table
			theads: [
				{
					name: "SKU",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: null,
				},
				{
					name: "Product Image",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: "width: 10%;",
				},
				{
					name: "Product",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: "width: 30%;",
				},
				{
					name: "Type",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: null,
				},
				{
					name: "Age",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: null,
				},
				{
					name: "Brand",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: null,
				},
				{
					name: "Cost",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: null,
				},
				{
					name: "Retail Price",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: null,
				},
				{
					name: "Quantity",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: "width: 10%;",
				},
				{
					name: "Subscription",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: null,
				},
				{
					name: null,
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: "width: 5%;",
				},
			],
			nameDuplicateWarning: false,
			checkNameLoading: false,
			isImageChanged: false,
			imageUrl: "",
			breedId: "",
			bundleDescription: "",
			bundleId: "",
			isPriceChange: false,
			selectingProduct: false,
		}
	},
	watch: {
		// tableContent.tableData
		'tableContent.tableData': {
			immediate: true,
			handler(newTableContentVal) {
				let isProductEdited = true
				if(this.bundleEditDetails) {
					const productIds = this.bundleEditDetails.products.map(obj => ({id: obj.id.toString(), productQuantity: obj.productQuantity}))
					const tableProductIds = this.tableContent.tableData.map(obj => ({id: obj.id.toString(), productQuantity: obj.productQuantity}))
					const areEqual = _.isEqual(productIds, tableProductIds);

					if (areEqual){
						isProductEdited = false
						this.isShowNote = false
						this.price = this.bundleEditDetails.price
						this.salePrice = this.bundleEditDetails.salePrice
						this.monthlyPrice = this.bundleEditDetails.price
					} else {
						this.isShowNote = true
					}
				}
					
				if(newTableContentVal.length > 0 && isProductEdited) {
					let totalPrice = 0
					for (let i = 0, l = newTableContentVal.length; i < l; i++) {
						let product = newTableContentVal[i]
						let cleanedStr = product.price.replace(/,/g, '');
						let priceVal = Number(cleanedStr);
						totalPrice = parseFloat(priceVal) + parseFloat(totalPrice)
					}

					if (this.subscriptionFlag) {
						this.monthlyPrice = parseFloat(totalPrice)
						this.formatNumberField('monthlyPrice')
					}  else  {
						this.price = parseFloat(totalPrice)
						this.formatNumberField('price');

						if (this.onSale) {
							this.$v.salePrice.$touch()
						}

					}
				} else if(isProductEdited){
					if (this.subscriptionFlag) {
						this.monthlyPrice = 0
						this.formatNumberField('monthlyPrice')
					} else {
						this.price = 0
						this.formatNumberField('price');

						if (this.onSale) {
							this.$v.salePrice.$touch()
						}
					}
				}
			},
			deep: true
		},
		'$route': {
			async handler(url) {
				const { action } = url.query;

				// hide select products table when back in the browser is clicked
				if(!action || action !== 'add-product'){
					this.selectingProduct = false;
				}
			}
		},
	},
	computed: {
		validationRules() {
			let fields = {
				bundleName: {},
				// imageUrl: {},
				// selectedSize: {},
				// selectedAge: {}
			}
			// const subscriptionFields = {
			// 	monthlyPrice: {},
			// 	quarterlyPrice: {},
			// 	yearlyPrice: {}
			// };

			fields = vuelidateUtil.setFieldsRequired(fields, true)

			if (this.onSale) {
				fields.salePrice = {}
				fields = vuelidateUtil.setFieldsRequired(fields, true)
			}

			fields.price = {}
			// fields = {...fields, ...subscriptionFields};
			if (this.subscriptionFlag) {
				// fields = vuelidateUtil.setRequiredValidation(fields, 'monthlyPrice');
				// fields = vuelidateUtil.setRequiredValidation(fields, 'quarterlyPrice');
				// fields = vuelidateUtil.setRequiredValidation(fields, 'yearlyPrice');
				// fields = vuelidateUtil.setMinValueValidation(fields, 'monthlyPrice', 0);
				// fields = vuelidateUtil.setMinValueValidation(fields, 'quarterlyPrice', 0);
				// fields = vuelidateUtil.setMinValueValidation(fields, 'yearlyPrice', 0);
				// fields.price = {};
			} else {
				fields = vuelidateUtil.setRequiredValidation(fields, "price")
				fields = vuelidateUtil.setMinValueValidation(fields, "price", 0)

				if (this.onSale) {
					fields = vuelidateUtil.setRequiredValidation(fields, "salePrice")
					fields = vuelidateUtil.setMinValueValidation(fields, "salePrice", 1)
				}
				// fields = {...fields, ...subscriptionFields};
			}

			return fields
		},
		compareFields() {
			const {
				name: editBundleName,
				subscriptionBundle: editSubscriptionFlag,
				price: editPrice,
				quarterlyPrice: editQuarterlyPrice,
				yearlyPrice: editYearlyPrice,
				age: editAge,
				breedSize: { id: editBreedSizeId },
				description,
				salePrice,
				onSale,
			} = this.bundleEditDetails

			const compareBundleName = editBundleName !== this.bundleName || editBundleName === this.bundleName
			const compareSubscriptionFlag = editSubscriptionFlag !== this.subscriptionFlag
			const compareAge = editAge !== this.selectedAge
			const compareBreedSize = editBreedSizeId !== this.selectedSize
			const compareBundleDescription = (description ? description : "") !== this.bundleDescription
			const compareSalePrice =
				salePrice !== this.salePrice && this.onSale && parseFloat(this.salePrice) < parseFloat(this.price)
			const compareOnSale = this.onSale != onSale

			let comparePrice = editPrice !== this.price
			let compareQuarterlyPrice = false
			let compareYearlyPrice = false

			if (this.subscriptionFlag) {
				comparePrice = editPrice !== this.monthlyPrice
				compareQuarterlyPrice = editQuarterlyPrice !== this.quarterlyPrice
				compareYearlyPrice = editYearlyPrice !== this.yearlyPrice
			}

			this.isPriceChange = comparePrice || compareSalePrice || compareQuarterlyPrice || compareYearlyPrice

			return !(
				this.compareProducts ||
				compareBundleName ||
				compareSubscriptionFlag ||
				comparePrice ||
				compareQuarterlyPrice ||
				compareYearlyPrice ||
				compareAge ||
				compareBreedSize ||
				this.hasBreedListChanges ||
				this.isImageChanged ||
				compareBundleDescription ||
				compareSalePrice ||
				compareOnSale
			)
		},
		compareProducts() {
			const { productsList: previousBundleProducts } = this.bundleEditDetails
			if (!previousBundleProducts) {
				return true
			}
			let currentProduct = this.tableContent ? this.tableContent.tableData : []
			const compareProductLength = currentProduct.length !== previousBundleProducts.length

			if (compareProductLength) {
				return true
			}

			// compare object properties.
			for (let i = 0; i < previousBundleProducts.length; i++) {
				const {
					name: currentProductName,
					brand: { currentProductBrandName },
					productQuantity: currentBundleProductQuantity,
					productType: currentBundleProductType,
					isSubscription: currentProductSubscription,
				} = currentProduct[i]
				const {
					name: previousProductName,
					brand: { previousProductBrandName },
					productQuantity: previousBundleProductQuantity,
					productType: previousBundleProductType,
					isSubscription: previousProductSubscription,
				} = previousBundleProducts[i]
				const compareProductName = currentProductName !== previousProductName
				const compareProductBrandName = currentProductBrandName !== previousProductBrandName
				const compareBundleProductQuantity = currentBundleProductQuantity !== previousBundleProductQuantity
				const compareBundleProductType = currentBundleProductType !== previousBundleProductType
				const compareProductSubscription = currentProductSubscription !== previousProductSubscription
				const evaluatedComparison =
					compareProductName ||
					compareProductBrandName ||
					compareBundleProductQuantity ||
					compareBundleProductType ||
					compareProductSubscription

				if (evaluatedComparison) {
					return evaluatedComparison
				}
			}

			return false
		},
		compareFieldsDogBundle() {
			const { name: editBundleName, price: editPrice } = this.bundleEditDetails

			let compareBundleName = editBundleName !== this.bundleName
			let comparePrice = editPrice !== this.price

			return !(this.compareProducts || compareBundleName || comparePrice || this.isImageChanged)
		},
		isInvalid() {
			let isInvalid

			if (this.bundleEditDetails) {
				if (this.dogBundleFlag) {
					isInvalid =
						this.isValid() ||
						this.compareFieldsDogBundle ||
						this.isAPILoading ||
						this.tableContent.tableData.length === 0
				} else {
					// isInvalid = this.$v.$invalid || this.isAPILoading || this.tableContent.tableData.length === 0 || this.compareFields;
					isInvalid = this.$v.$invalid || this.isAPILoading || this.compareFields
				}
			} else {
				if (this.dogBundleFlag) {
					isInvalid = this.isValid() || this.isAPILoading || this.tableContent.tableData.length === 0
				} else {
					isInvalid = this.nameDuplicateWarning || this.$v.$invalid || this.isAPILoading
					// isInvalid = this.$v.$invalid || this.isAPILoading || this.tableContent.tableData.length === 0;
				}
			}

			return isInvalid
		},
		isValidSalePrice() {
			if(this.subscriptionFlag)
				return false

			return parseFloat(this.salePrice) >= parseFloat(this.price)
		},
		isValidMonthlyPrice() {
			if(!this.subscriptionFlag)
				return true

			return parseFloat(this.monthlyPrice) > 0
		},
		totalProductsCost() {
			const total = this.tableContent.tableData.reduce((sum, product) => {
				const cost = product.cost.replace(/,/g, "")
				return sum + parseFloat(cost || 0)
			}, 0)

			const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
			const formattedNumber = total.toLocaleString(undefined, options)

			return `$${formattedNumber}`
		},
		totalRetailPrice() {
			const total = this.tableContent.tableData.reduce((sum, product) => {
				const retailPrice = product.price.replace(/,/g, "")
				return sum + parseFloat(retailPrice || 0)
			}, 0)

			const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
			const formattedNumber = total.toLocaleString(undefined, options)

			return `$${formattedNumber}`
		},
	},
	async created() {
		this.setFieldsForUpdate()
		this.getSubscriptionPeriodList()
	},
	methods: {
		setFieldsForUpdate() {
			const ageList = { A: "Adult", P: "Puppy" }
			if (this.$route.params && this.$route.params.id) {
				this.isAPILoading = true

				let data = this.$route.params.id.split("-")

				if (data[1] === "dogBundle") {
					this.dogBundleFlag = true

					let queryParams = {
						f_id: data[0],
					}

					BundleService.getBundles(queryParams)
						.then((res) => {
							if (res.status === STATUS_CODES.SUCCESS) {
								const { breed, name: bundleName, price, imageUrl, products } = res.data.data[0]
								this.bundleName = bundleName
								this.imageUrl = imageUrl
								this.price = price
								this.breedId = breed ? breed.id : null

								if (products) {
									const processedProducts = products.map((product) => {
										return {
											id: product.id,
											name: product.name,
											price: product.price,
											cost: product.cost,
											brand: product.brand,
											productQuantity: product.productQuantity,
											imageUrl: product.imageUrl,
											productType: product.productType.name,
											isSubscription: product.subscriptionBundle,
											age: ageList[product.age] ? ageList[product.age] : "Adult/Puppy",
											isOutOfStock: product.productInventory.stockQty <= 0,
											isInactive: product.status === PRODUCT_STATUS.INACTIVE
										}
									})
									this.bundleEditDetails = {
										...res.data.data[0],
										productsList: [...processedProducts],
									}
									this.tableContent.tableData = processedProducts
								} else {
									this.bundleEditDetails = {
										...res.data.data[0],
									}
								}
							} else {
								this.showAPIErrorToast("Unable to fetch bundles list.", res)
							}

							this.isAPILoading = false
						})
						.catch(() => {
							this.showGenericErrorToast()
							this.isAPILoading = false
						})
				} else {
					BundleService.getBundleById(this.$route.params.id).then((res) => {
						if (res.status === STATUS_CODES.SUCCESS) {
							const {
								name: bundleName,
								price,
								quarterlyPrice,
								yearlyPrice,
								age,
								imageUrl,
								subscriptionBundle,
								products,
								description,
								breeds,
								breedSize: { id: breedSizeId },
								onSale,
								salePrice,
								id,
							} = res.data

							let validationFields = ["bundleName"]

							this.bundleId = id
							this.bundleName = bundleName
							this.subscriptionFlag = subscriptionBundle
							this.imageUrl = imageUrl
							this.selectedSize = breedSizeId
							this.selectedAge = age
							this.bundleDescription = description ? description : ""
							this.onSale = onSale
							this.salePrice = salePrice
							this.applicableBreeds = breeds.map(({ breedId, name, status }) => {
								return {
									id: breedId,
									name,
									status,
								}
							})

							if (subscriptionBundle) {
								this.monthlyPrice = price
								this.quarterlyPrice = quarterlyPrice
								this.yearlyPrice = yearlyPrice
								// validationFields = [...validationFields, 'monthly', 'quarterly', 'yearly'];
							} else {
								this.price = price
								validationFields.push("price")
							}

							if (products) {
								const processedProducts = products.map((product) => {
									const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }

									/*  format numbers, add comma for thousands and max two decimal points */
									const cost = parseFloat(
										product.productInventory.cost * product.productQuantity || 0
									)
									const formattedCost = cost.toLocaleString(undefined, options) || "0.00"

									const costIncTax = parseFloat(
										product.productInventory.costIncTax * product.productQuantity || 0
									)
									const formattedCostIncTax = costIncTax.toLocaleString(undefined, options) || "0.00"

									const price = parseFloat(product.price * product.productQuantity || 0)
									const formattedPrice = price.toLocaleString(undefined, options) || "0.00"

									return {
										id: product.id,
										name: product.name,
										cost: formattedCost,
										costIncTax: formattedCostIncTax,
										price: formattedPrice,
										baseCost: product.productInventory.cost,
										baseCostIncTax: product.productInventory.costIncTax,
										basePrice: product.price,
										brand: product.brand,
										productQuantity: product.productQuantity,
										imageUrl: product.imageUrl,
										productType: product.productType.name,
										isSubscription: product.subscriptionBundle,
										age: ageList[product.age] ? ageList[product.age] : "Adult/Puppy",
										isOutOfStock: product.productInventory.stockQty <= 0,
										isInactive: product.status === PRODUCT_STATUS.INACTIVE
									}
								})
								this.bundleEditDetails = {
									...res.data,
									productsList: [...processedProducts],
								}
								this.tableContent.tableData = processedProducts
							} else {
								this.bundleEditDetails = {
									...res.data,
								}
							}
							if (this.$route.name === "Copy Doggy Pack") {
								this.getCheckBundleName()
							}
							// trigger vuelidate
							// validationFields.forEach(field => this.onBlur(field));
						} else {
							this.showCustomErrorToast(this.toastMessages.bundles().ERROR_GET_BUNDLE)
						}

						this.isAPILoading = false
					})
				}
			}
		},
		onSubmit(type, addMoreFlag = false) {	
			if (this.isInvalid) {
				return
			}

			let apiType

			if (type === "Add Doggy Pack" || type === "Copy Doggy Pack") {
				apiType = "add"
			} else {
				apiType = "edit"
			}
			if (this.dogBundleFlag) {
				this.callDogBundlesAPI(apiType, addMoreFlag)
			} else {
				this.callBundlesAPI(apiType, addMoreFlag)
			}
		
		},
		callBundlesAPI(apiType, addMoreBundlesFlag) {
			// this.isAPILoading = true
			this.isSendingAPIRequest = true;

			const { SUCCESS_ADD_BUNDLE, SUCCESS_EDIT_BUNDLE, ERROR_ADD_BUNDLE, ERROR_EDIT_BUNDLE } =
				this.toastMessages.bundles()

			const products = this.tableContent.tableData.map(({ id, productQuantity }) => {
				return {
					id,
					productQuantity,
				}
			})
			const breeds = this.breedList.map(({ id: breedId, status }) => {
				return {
					breedId,
					status,
				}
			})

			let formDetails = {
				name: this.bundleName,
				subscriptionBundle: this.subscriptionFlag,
				price: this.price,
				breedSizeId: this.selectedSize,
				age: this.selectedAge,
				breeds,
				products,
				isImageChanged: this.isImageChanged,
				description: this.bundleDescription,
				copyPhoto: this.imageUrl,
				onSale: this.onSale,
				salePrice: this.salePrice,
			}

			if (this.subscriptionFlag) {
				formDetails = {
					...formDetails,
					price: this.monthlyPrice,
					quarterlyPrice: this.quarterlyPrice,
					yearlyPrice: this.yearlyPrice,
				}
			}

			let bundleDetails = {
				formDetails,
				bundleImage: this.fileBlob ? this.fileBlob[0] : "",
			}

			if (apiType === "add") {
				BundleService.postAddBundle(bundleDetails).then((res) => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.resetFields()
						this.showCustomSuccessToast(SUCCESS_ADD_BUNDLE)

						if (!addMoreBundlesFlag) {
							this.$router.push("/doggy-packs")
						}
					} else {
						this.showAPIErrorToast(ERROR_ADD_BUNDLE, res)
					}

					// this.isAPILoading = false
					this.isSendingAPIRequest = false;
				})
			} else if (apiType === "edit") {
				bundleDetails = {
					...bundleDetails,
					formDetails: { ...formDetails, isPriceChange: this.isPriceChange },
				}

				BundleService.putUpdateBundle(this.$route.params.id, bundleDetails).then((res) => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(SUCCESS_EDIT_BUNDLE)
						this.$router.push("/doggy-packs")
					} else {
						this.showAPIErrorToast(ERROR_EDIT_BUNDLE, res)
					}

					// this.isAPILoading = false
					this.isSendingAPIRequest = false;
				})
			}

		},
		callDogBundlesAPI(apiType, addMoreBundlesFlag) {
			this.isSendingAPIRequest = true;

			const { SUCCESS_ADD_BUNDLE, SUCCESS_EDIT_BUNDLE, ERROR_ADD_BUNDLE, ERROR_EDIT_BUNDLE } =
				this.toastMessages.bundles()

			const products = this.tableContent.tableData.map(({ id, productQuantity, productType }) => {
				return {
					id,
					productQuantity,
				}
			})

			let formDetails = {
				name: this.bundleName,
				price: this.price,
				products,
				breedId: this.breedId,
				isImageChanged: this.isImageChanged,
			}

			const bundleDetails = {
				formDetails,
				bundleImage: this.fileBlob ? this.fileBlob[0] : "",
			}

			// this.isAPILoading = true

			if (apiType === "add") {
				BundleService.postDogBundle(bundleDetails).then((res) => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.resetFields()
						this.showCustomSuccessToast(SUCCESS_ADD_BUNDLE)
					} else {
						this.showAPIErrorToast(ERROR_ADD_BUNDLE, res)
					}

					if (!addMoreBundlesFlag) {
						this.$router.push("/doggy-packs")
					}

					// this.isAPILoading = false
					this.isSendingAPIRequest = false;
				})
			
			} else if (apiType === "edit") {
				let data = this.$route.params.id.split("-")

				BundleService.putDogBundle(data[0], bundleDetails).then((res) => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(SUCCESS_EDIT_BUNDLE)
						this.$router.push("/doggy-packs")
					} else {
						this.showAPIErrorToast(ERROR_EDIT_BUNDLE, res)
					}

					// this.isAPILoading = false
					this.isSendingAPIRequest = false;
				})
			}
		},
		resetCustomFields() {
			this.bundleEditDetails = false
			this.bundleName = ""
		},
		showAddProductToBundleModal() {
			this.$refs.modalAddProduct.show(this.selectedAge)
		},
		addProductToBundle(product) {
			const isProductExist = this.tableContent.tableData.find((item) => item.id === product.id)
			const { ERROR_ADD_PRODUCT_MSG, ERROR_ADD_PRODUCT_TITLE } = this.toastMessages.bundles()

			if (!isProductExist) {
				// get breed id if Breed and dogBundleFlag is true
				if (this.dogBundleFlag && product.productType === "Breed") {
					ProductService.getProductDogById(product.id).then((res) => {
						if (res.status === STATUS_CODES.SUCCESS) {
							const { breedId } = res.data
							this.breedId = breedId
						}
					})
				}

				this.tableContent.tableData = [...this.tableContent.tableData, product]
			} else {
				this.showCustomErrorToast(ERROR_ADD_PRODUCT_TITLE, ERROR_ADD_PRODUCT_MSG)
			}
		},
		deleteProduct({ id: productId, name: productName }) {
			const productIndex = this.tableContent.tableData.findIndex((item) => item.id === productId)
			this.$swal({
				title: "Delete Product",
				text: `Are you sure you want to delete ${productName}?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {
				if (result.value) {
					this.isShowNote = true
					this.tableContent.tableData.splice(productIndex, 1)
					this.showCustomSuccessToast(this.toastMessages.bundles().SUCCESS_DELETE_PRODUCT_TITLE)
				}
			})
		},
		handleBreedListUpdate(breedList) {
			this.breedList = breedList
		},
		handleBreedListChanges(hasChange) {
			this.hasBreedListChanges = hasChange
		},
		hasProductImage(productImage) {
			let image = require("@/assets/images/temporary/product-image.png")

			if (productImage) {
				image = productImage
			}

			return image
		},
		checkDuplicateName() {
			this.delayTyping(() => {
				if (this.bundleName !== "") {
					this.getCheckBundleName()
				}
			})
		},
		getCheckBundleName() {
			const body = {
				f_name: this.bundleName,
			}
			this.nameDuplicateWarning = false
			this.checkNameLoading = true

			BundleService.getBundleByName(body).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					// check if there is already a product with the same name then ask for confirmation
					if (res.data.bundleCount > 0) {
						this.nameDuplicateWarning = true
					}
				} else {
					this.showAPIErrorToast("Unable to check the doggy pack name.", res)
				}
				this.checkNameLoading = false
			})
		},
		isValid() {
			return (parseFloat(this.price) > 0 && this.imageUrl != "" && this.bundleName != "" && this.bundleName != null)
		},
		replaceBodyWithPetName(newDescription) {
			this.bundleDescription = newDescription
		},
		insertName() {
			this.bundleDescription =
				this.bundleDescription === ""
					? this.bundleDescription + "PET_NAME"
					: this.bundleDescription + " PET_NAME "
		},
		showModalFindReplaceWithPetName() {
			this.$refs.modalFindReplaceWithPetName.show(this.bundleDescription)
		},
		getAgeClass(age) {
			const ageList = { A: "Adult", P: "Puppy" }
			if (this.selectedAge && age !== "Adult/Puppy") {
				return age !== ageList[this.selectedAge]
			}
			return false
		},
		async goToProductSelection() {
			this.selectingProduct = true
			this.isShowNote = true

			const fullPath = this.$route.fullPath;

			if(fullPath && fullPath.includes("edit")){
				this.$router.push({ path: `/doggy-packs/edit/${this.$route.params.id}`, query: { action: "add-product" } });
			} else {
				this.$router.push({ path: `/doggy-packs/add`, query: { action: "add-product" } });

			}

		},
		parseLocaleNumber(localeString) {
			if(!localeString){
				return 0;
			}
			
			const cleanedString = localeString.toString().replace(/[^0-9.]/g, ''); // Remove any non-numeric characters except for the decimal point
			return parseFloat(cleanedString); // Convert the cleaned string to a number
		},
		addSelectedProducts(selectedProducts) {

			const processedProducts = selectedProducts.map((product) => {
				const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }

				/*  format numbers, add comma for thousands and max two decimal points */
				const cost = this.parseLocaleNumber(product.cost).toLocaleString(undefined, options) || "0.00"
				const costIncTax = this.parseLocaleNumber(product.costIncTax).toLocaleString(undefined, options) || "0.00"
				const price = this.parseLocaleNumber(product.price).toLocaleString(undefined, options) || "0.00"

				return {
					id: product.id,
					name: product.name,
					price,
					cost,
					costIncTax,
					baseCost: product.baseCost ? product.baseCost : cost,
					baseCostIncTax: product.costIncTax,
					basePrice: product.basePrice ? product.basePrice : price,
					brand: product.brand,
					productQuantity: product.productQuantity ? product.productQuantity : 1,
					imageUrl: product.imageUrl,
					productType: product.productType,
					isSubscription: product.isSubscription,
					age: product.age,
					onSale: product.onSale,
					salePrice: product.salePrice,
					isOutOfStock: product.isOutOfStock,
					isInactive: product.isInactive
				}
			})
			this.selectingProduct = false
			this.tableContent.tableData = [...processedProducts]
		},
		handleChangeProductQty(selectedProduct, event) {
			const quantity = parseFloat(event.target.value) || 1
			this.tableContent.tableData = this.tableContent.tableData.map((product) => {
				if (product.id === selectedProduct.id) {
					const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }

					const { baseCost, baseCostIncTax, basePrice } = product
					
					const cost = baseCost ? this.parseLocaleNumber(baseCost) * quantity : 0
					const formattedCost = cost.toLocaleString(undefined, options)

					const costIncTax = parseFloat(baseCostIncTax) * quantity
					const formattedCostIncTax = costIncTax.toLocaleString(undefined, options)

					const price = parseFloat(basePrice) * quantity
					const formattedPrice = price.toLocaleString(undefined, options)
							

					return {
						...product,
						cost: formattedCost,
						baseCost,
						costIncTax: formattedCostIncTax,
						price: formattedPrice,
						productQuantity: quantity,
					}
				}

				return product
			})
		},
		allowOnlyNumbers(e) {
			const invalidChars = ["-", "+", "e", "E"]
			if (invalidChars.includes(e.key)) {
				e.preventDefault()
			}
		},
	},
	// third party libraries
	validations() {
		return this.validationRules
	},
}
